import * as React from 'react';
import { ReactComponent as ExternalLinkIcon } from '../../../assets/svg/icons/external-link.svg';
import { cn } from '../../../helpers';

import './link-list-large.style.scss';

export default function LinkListLarge(props: LinkListLargeProps) {
    const { list, maxLength, className } = props;
    const items = maxLength ? list.slice(0, maxLength) : list;
    return (
        <ul className={cn('link-list-large', className)}>
            {items.map((link: LinkListLargeItem) => (
                <li key={link.text} className="link-list-large__item hover-pop-effect">
                    <a href={link.url} title="" className="link-list-large__link" target="_blank" rel="noopener noreferrer">
                        <p className="link-list-large__category">{link.title}</p>
                        <h3 className="link-list-large__title">
                            {link.text}
                            <ExternalLinkIcon className="link-list-large__icon" />
                        </h3>
                    </a>
                </li>
            ))}
        </ul>
    );
}
